import { render } from "./scroll-button.vue?vue&type=template&id=dc661816"
import script from "./scroll-button.vue?vue&type=script&lang=js"
export * from "./scroll-button.vue?vue&type=script&lang=js"

import "./scroll-button.vue?vue&type=style&index=0&id=dc661816&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__